export default __webpack_public_path__ + "static/media/flag_saint_helena.22951261.svg";